import {useEffect, useRef} from "react";
import {InfiniteData} from "@reduxjs/toolkit/query";
import {Pagination} from "@/types/extenions.ts";


export const useRefInfinity = (feachNextPage: () => void, state:  InfiniteData<Pagination<any>, number> | undefined) => {

    const ref = useRef(null);

    const isNeedFetch = state?.pages[state.pages.length - 1].next !== null;

    {/*    use IntersectionObserver to fetchNextPage   */}

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && isNeedFetch) {
                feachNextPage();
            }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        }
    }, [ref.current, feachNextPage]);

    return ref;
}